import React from "react";

export default function NoItems(){
    return(<p className={'message'}>No items</p>)
}